import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  sessionId: z.string().min(1),
});

export type InputType = z.infer<typeof schema>;

export type PresenceParticipant = {
  userId: number;
  displayName: string;
  avatarUrl: string | null;
  currentFile: string | null;
  cursorLine: number | null;
  cursorColumn: number | null;
  selection: {
    startLine: number | null;
    startColumn: number | null;
    endLine: number | null;
    endColumn: number | null;
  } | null;
  lastSeenAt: Date | null;
  status: 'online' | 'meeting' | 'away' | 'offline';
  color: string; // Computed color for UI
  // AI participant fields
  isAi?: boolean;
  personaId?: string;
  personaCategory?: string;
};

export type OutputType = {
  participants: PresenceParticipant[];
};

export const getPresenceList = async (
  input: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const params = new URLSearchParams({ sessionId: input.sessionId });
  const result = await fetch(`/_api/presence/list?${params.toString()}`, {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
